module.exports = __webpack_public_path__ + "static/media/img_11.7b3754e0.png";